//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentRowToolbar",
  props: {
    download: {
      type: Boolean,
      default: true
    },
    downloading: {
      type: Boolean,
      default: false
    },
    uploadedByCoApplicant: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(eventName) {
      this.$emit(eventName);
    }
  }
});